import FormGroup from '../../../generic/FormGroup';
import translations from '../../../../translations';
import ValueSelectorModal from '../../../values/selector/ValueSelectorModal';
import type { ValueElementIdAPI } from '../../../../types/value';
import type { Agent } from '../../../../types/graph';

interface Props {
    value: ValueElementIdAPI | null;
    onChange: (agent: Partial<Agent>) => void;
    isRequired: boolean;
    hasSubmitted: boolean;
    container: HTMLElement | null;
}

const AgentSessionId = ({ value, onChange, hasSubmitted, isRequired, container }: Props) => {
    return (
        <FormGroup
            label={translations.AGENT_session_id_label}
            testId={translations.AGENT_session_id_label}
            isRequired={isRequired}
            isValid={!isRequired || !!value}
            showValidation={hasSubmitted}
            validationMessage={translations.AGENT_session_id_required}
        >
            <ValueSelectorModal
                includeSystemValues={false}
                value={value}
                onChange={(sessionId) => onChange({ sessionId })}
                container={container}
                contentType="ContentString"
            />
        </FormGroup>
    );
};

export default AgentSessionId;
